/**
 * Pulls the reason the API sent with a failed request, so a blocked action
 * explains itself instead of showing a generic "ocurrió un error".
 *
 * NestJS answers validation failures with an array of messages and everything
 * else with a single string, so both shapes are handled. Anything without a
 * usable message (network errors, empty payloads) falls back to the caller's
 * copy rather than opening a blank alert.
 */
export const serverMessage = (error: unknown, fallback: string): string => {
  const message = (
    error as { response?: { data?: { message?: string | string[] } } }
  )?.response?.data?.message;

  if (Array.isArray(message)) {
    return message.length > 0 ? message.join(", ") : fallback;
  }

  return message || fallback;
};
